module.exports = __webpack_public_path__ + "static/media/win-soul.870492cf.gif";